 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","AIAgent":"AIAgent","Address":"Address","AdminDetail":"AdminDetail","AdminList":"AdminList","CreateAdmin":"CreateAdmin","Dashboard~Order":"Dashboard~Order","Dashboard":"Dashboard","Order":"Order","Icons":"Icons","Ongkir":"Ongkir","OngkirCreateOrder~OrderShipping":"OngkirCreateOrder~OrderShipping","OrderShipping":"OrderShipping","OpenApi":"OpenApi","OrderConfirmation":"OrderConfirmation","OrderDetail~Report":"OrderDetail~Report","OrderDetail":"OrderDetail","Report":"Report","OrderLogistic":"OrderLogistic","PackageDetail":"PackageDetail","Registration":"Registration","ResetPassword":"ResetPassword","Toast":"Toast","Tracking":"Tracking","TrackingDetail":"TrackingDetail","VerificationError":"VerificationError","Voucher":"Voucher","Login":"Login","OngkirCreateOrder":"OngkirCreateOrder","header":"header","loading":"loading","sidebar":"sidebar","illustration":"illustration","Button":"Button","Forms":"Forms","Modal":"Modal","Pagination":"Pagination","Table":"Table","LogisticPlaceholder":"LogisticPlaceholder","chart":"chart","card":"card","AddressFormModal":"AddressFormModal","Complain":"Complain","Receipt":"Receipt","Toggle":"Toggle","Carousel":"Carousel","ToastItem":"ToastItem","ToggleLanguage":"ToggleLanguage"}[chunkId]||chunkId) + "." + {"404":"436c3037","AIAgent":"100cec45","Address":"e7c2de73","AdminDetail":"3eebe085","AdminList":"31d120dd","CreateAdmin":"4003a1cd","Dashboard~Order":"4a46dc87","Dashboard":"a171bc81","Order":"7fd86c86","Icons":"02444057","Ongkir":"5997f1a5","OngkirCreateOrder~OrderShipping":"0647f4f4","OrderShipping":"36b36b05","OpenApi":"3f364ad1","OrderConfirmation":"88812b16","OrderDetail~Report":"64b443ad","OrderDetail":"718d36bb","Report":"53ce3554","OrderLogistic":"7b90df54","PackageDetail":"6923b727","Registration":"f343202e","ResetPassword":"1ce150e0","Toast":"e9f3ff02","Tracking":"a190e5d9","TrackingDetail":"48098ebe","VerificationError":"2950346f","Voucher":"5cc80120","chunk-1c2634d9":"e06785ee","chunk-2b21b53f":"b80939f8","chunk-2d0e8e9d":"ad322329","Login":"42e4d6b4","chunk-e1e06640":"2a27e8f3","OngkirCreateOrder":"12af1b5d","chunk-9b1bc8e2":"5d0d3451","chunk-bc9c78d6":"c7410a13","chunk-c421aa40":"7fa38063","chunk-e046aa00":"6eb4ccda","header":"7a302ce5","loading":"16322c1a","sidebar":"de86ede6","illustration":"38620390","Button":"9198b07c","Forms":"237b4954","Modal":"e2162a39","Pagination":"099e56f5","Table":"12311ad0","LogisticPlaceholder":"f21f7710","chart":"f4f8f6f3","card":"5e49ede6","AddressFormModal":"ff268ebe","chunk-2d0b2136":"bb10e9c4","Complain":"589134ed","Receipt":"25619a84","chunk-2d0cbb1d":"44652b1d","chunk-2d0c20d9":"952f2524","Toggle":"9df6d4d7","chunk-18a208a2":"ac281580","chunk-2d0c1cfb":"99f9f465","chunk-2d0dd600":"912355f0","chunk-2d0e6296":"63a668f1","chunk-2d208a1e":"86504d3c","chunk-2d21b23f":"778e0345","chunk-2d237137":"ca191435","chunk-771a1f1a":"5d86226c","Carousel":"7cfcff9b","ToastItem":"df32ac07","chunk-5bf0c168":"da0a381b","chunk-02e638d6":"c1634fc8","chunk-2d20940d":"dff282ac","chunk-2d22b9ad":"dd3a6348","chunk-07c304d6":"8ae412bb","ToggleLanguage":"43dfbbe8","chunk-26d1e9d8":"07918653","chunk-2d2223d9":"0e8419b9","chunk-2d216214":"a9f4880f","chunk-77482378":"c39e498f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"AIAgent":1,"Address":1,"Dashboard~Order":1,"Dashboard":1,"Order":1,"Icons":1,"Ongkir":1,"OngkirCreateOrder~OrderShipping":1,"OrderShipping":1,"OrderConfirmation":1,"OrderDetail":1,"Report":1,"OrderLogistic":1,"Registration":1,"ResetPassword":1,"Toast":1,"Tracking":1,"Voucher":1,"chunk-1c2634d9":1,"chunk-2b21b53f":1,"Login":1,"OngkirCreateOrder":1,"chunk-9b1bc8e2":1,"chunk-bc9c78d6":1,"chunk-c421aa40":1,"chunk-e046aa00":1,"header":1,"loading":1,"sidebar":1,"Button":1,"Forms":1,"Modal":1,"Table":1,"card":1,"AddressFormModal":1,"Toggle":1,"chunk-18a208a2":1,"Carousel":1,"ToastItem":1,"chunk-5bf0c168":1,"chunk-02e638d6":1,"chunk-07c304d6":1,"chunk-26d1e9d8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","AIAgent":"AIAgent","Address":"Address","AdminDetail":"AdminDetail","AdminList":"AdminList","CreateAdmin":"CreateAdmin","Dashboard~Order":"Dashboard~Order","Dashboard":"Dashboard","Order":"Order","Icons":"Icons","Ongkir":"Ongkir","OngkirCreateOrder~OrderShipping":"OngkirCreateOrder~OrderShipping","OrderShipping":"OrderShipping","OpenApi":"OpenApi","OrderConfirmation":"OrderConfirmation","OrderDetail~Report":"OrderDetail~Report","OrderDetail":"OrderDetail","Report":"Report","OrderLogistic":"OrderLogistic","PackageDetail":"PackageDetail","Registration":"Registration","ResetPassword":"ResetPassword","Toast":"Toast","Tracking":"Tracking","TrackingDetail":"TrackingDetail","VerificationError":"VerificationError","Voucher":"Voucher","Login":"Login","OngkirCreateOrder":"OngkirCreateOrder","header":"header","loading":"loading","sidebar":"sidebar","illustration":"illustration","Button":"Button","Forms":"Forms","Modal":"Modal","Pagination":"Pagination","Table":"Table","LogisticPlaceholder":"LogisticPlaceholder","chart":"chart","card":"card","AddressFormModal":"AddressFormModal","Complain":"Complain","Receipt":"Receipt","Toggle":"Toggle","Carousel":"Carousel","ToastItem":"ToastItem","ToggleLanguage":"ToggleLanguage"}[chunkId]||chunkId) + "." + {"404":"a9cbf281","AIAgent":"a095bf7a","Address":"ebfa784a","AdminDetail":"31d6cfe0","AdminList":"31d6cfe0","CreateAdmin":"31d6cfe0","Dashboard~Order":"61d9c667","Dashboard":"cf119132","Order":"57c473dc","Icons":"58e3a43c","Ongkir":"a27075f2","OngkirCreateOrder~OrderShipping":"75edc02c","OrderShipping":"d22282ed","OpenApi":"31d6cfe0","OrderConfirmation":"e8f4d5db","OrderDetail~Report":"31d6cfe0","OrderDetail":"f9263c63","Report":"12d60d7b","OrderLogistic":"d326eb7c","PackageDetail":"31d6cfe0","Registration":"b537a669","ResetPassword":"80fa5edd","Toast":"f45876c2","Tracking":"e94bbdae","TrackingDetail":"31d6cfe0","VerificationError":"31d6cfe0","Voucher":"1d6357b8","chunk-1c2634d9":"413be254","chunk-2b21b53f":"0ffd4f77","chunk-2d0e8e9d":"31d6cfe0","Login":"883da903","chunk-e1e06640":"31d6cfe0","OngkirCreateOrder":"093bdc96","chunk-9b1bc8e2":"7aff9442","chunk-bc9c78d6":"af833b6f","chunk-c421aa40":"40a6b779","chunk-e046aa00":"124b2fe1","header":"0989dfd0","loading":"e90d99f8","sidebar":"e0ae6948","illustration":"31d6cfe0","Button":"b93ed62c","Forms":"264ee439","Modal":"40a6b779","Pagination":"31d6cfe0","Table":"98cc949d","LogisticPlaceholder":"31d6cfe0","chart":"31d6cfe0","card":"2675e230","AddressFormModal":"c0d3b39d","chunk-2d0b2136":"31d6cfe0","Complain":"31d6cfe0","Receipt":"31d6cfe0","chunk-2d0cbb1d":"31d6cfe0","chunk-2d0c20d9":"31d6cfe0","Toggle":"943678e8","chunk-18a208a2":"057106ae","chunk-2d0c1cfb":"31d6cfe0","chunk-2d0dd600":"31d6cfe0","chunk-2d0e6296":"31d6cfe0","chunk-2d208a1e":"31d6cfe0","chunk-2d21b23f":"31d6cfe0","chunk-2d237137":"31d6cfe0","chunk-771a1f1a":"31d6cfe0","Carousel":"1105d523","ToastItem":"bd62a59d","chunk-5bf0c168":"241dd6ec","chunk-02e638d6":"687124c0","chunk-2d20940d":"31d6cfe0","chunk-2d22b9ad":"31d6cfe0","chunk-07c304d6":"241dd6ec","ToggleLanguage":"31d6cfe0","chunk-26d1e9d8":"fc2157a9","chunk-2d2223d9":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-77482378":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
